// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__oW7a7"};